import React from "react";

const LoaderLogo = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 400 400"
      style={{ enableBackground: "new 0 0 400 400" }}
      xmlSpace="preserve"
    >
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#00c6ff", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#0072ff", stopOpacity: 1 }} />
        </linearGradient>
      </defs>

      {/* Assassin's Creed style emblem */}
      <path
        d="M200,40
           C180,120 150,180 200,340
           C250,180 220,120 200,40
           Z"
        fill="none"
        stroke="url(#grad1)"
        strokeWidth="6"
      />
      <path
        d="M200,70
           L170,220
           L200,260
           L230,220
           Z"
        fill="none"
        stroke="url(#grad1)"
        strokeWidth="4"
      />

      {/* Initials */}
      <text
        x="200"
        y="215"
        textAnchor="middle"
        fill="url(#grad1)"
        fontFamily="sans-serif"
        fontWeight="300"
        fontSize="48"
      >
        MS
      </text>

      {/* Name below emblem */}
      <text
        x="200"
        y="370"
        textAnchor="middle"
        fill="url(#grad1)"
        fontFamily="sans-serif"
        fontWeight="300"
        fontSize="28"
      >
        Mohamed Samir
      </text>
    </svg>
  );
};

export default LoaderLogo;
